var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bicon d-inline-block",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('bicon',{class:_vm.iconObject})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }